import React from 'react';
import { siteUrl } from '../native';
import InviteBanner from './InviteBanner';
import { APP_STORE_URL, LANGUAGES } from '../constants';
import { isNative } from '../native';
import { Icon } from './ui';

const DAYS = ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
// The app's own 2-hour blocks (design F31), 08:00 to 22:00.
const BLOCKS = ['08:00','10:00','12:00','14:00','16:00','18:00','20:00'];
const cell = (row, days) => days.map(d => row * 7 + d);

// You: weekday evenings and weekend middays. Them: overlapping, offset by a block.
const YOU  = [...cell(4, [0,1,2,3,4]), ...cell(5, [0,1,3]), ...cell(2, [5,6]), ...cell(3, [5,6])];
const THEM = [...cell(5, [0,1,2,3,4]), ...cell(4, [1,3]), ...cell(3, [5,6]), ...cell(6, [2])];
const BOTH = YOU.filter(i => THEM.includes(i));

// Sign in and Create your account open their own screens (design F31).
function Landing({ onSignIn, onSignUp }) {
  return (
    <div className="lp">
      <style>{`
        .lp { background:var(--bg); color:var(--ink); min-height:100vh; font-family:var(--sans); }
        .lp * { box-sizing:border-box; }

        .lp-bar {
          display:flex; justify-content:space-between; align-items:center;
          padding:16px; max-width:1180px; margin:0 auto;
        }
        .lp-mark { display:block; height:40px; width:auto; }
        .lp-signin { min-height:44px; padding:0 20px; font-size:14px; }

        .lp-hero {
          max-width:1180px; margin:0 auto; padding:24px 16px 48px;
          display:grid; grid-template-columns:1fr; gap:32px; align-items:center;
        }
        .lp-eyebrow {
          font-size:11px; font-weight:600; letter-spacing:3px; text-transform:uppercase;
          color:var(--accent); margin-bottom:16px;
        }
        .lp-h1 {
          font-family:var(--serif); font-weight:400; font-size:38px; line-height:1.05;
          letter-spacing:-.02em; margin:0 0 20px; color:var(--ink);
        }
        .lp-h1 em { font-style:italic; color:var(--accent); }
        .lp-sub { font-size:15px; line-height:1.6; color:var(--muted); max-width:32rem; margin:0 0 28px; }
        .lp-cta { min-height:56px; padding:0 32px; font-size:16px; }
        .lp-note { margin-top:16px; font-size:13px; color:var(--muted); }
        .lp-ctas { display:flex; flex-direction:column; align-items:flex-start; gap:12px; }
        .lp-badge img { display:block; height:48px; width:auto; }
        .lp-proof { list-style:none; max-width:1180px; margin:0 auto; padding:0 16px 40px; display:grid; grid-template-columns:repeat(2, minmax(0, 1fr)); gap:12px 16px; }
        .lp-proof li { display:flex; align-items:center; gap:8px; font-size:13px; color:var(--muted); line-height:1.35; }
        .lp-proof svg { flex-shrink:0; color:var(--accent); }
        .lp-tm { margin:12px auto 0; max-width:40rem; font-size:12px; line-height:1.5; }
        .lp-invite { margin-bottom:20px; }

        /* ---- signature: overlapping availability grids ---- */
        .lp-panel { background:var(--surface); border:1px solid var(--line); border-radius:20px; padding:20px; }
        .lp-panel-top {
          display:flex; justify-content:space-between; align-items:baseline; margin-bottom:16px;
          font-size:11px; font-weight:600; letter-spacing:2.5px; text-transform:uppercase; color:var(--muted);
        }
        .lp-grid { display:grid; grid-template-columns:2.8rem repeat(7,1fr); gap:6px 5px; align-items:center; }
        .lp-day, .lp-time { font-size:11px; color:var(--muted); display:flex; align-items:center; justify-content:center; }
        .lp-time { justify-content:flex-end; padding-right:6px; font-variant-numeric:tabular-nums; }
        .lp-cell { height:20px; border-radius:999px; background:var(--surface-2); border:1px solid var(--line-strong); }
        .lp-cell.you  { animation:fillYou .4s ease forwards; }
        .lp-cell.them { animation:fillThem .4s ease forwards; }
        .lp-cell.both { animation:fillBoth .5s ease forwards; }
        @keyframes fillYou  { to { background:var(--surface); border-color:var(--ink); } }
        @keyframes fillThem { to { background:#9A9F98; border-color:#9A9F98; } }
        @keyframes fillBoth { 0% { background:#9A9F98; } 100% { background:var(--accent); border-color:var(--accent); } }

        .lp-legend {
          display:flex; gap:16px; align-items:center; margin-top:16px; padding-top:16px;
          border-top:1px solid var(--divider); font-size:13px; color:var(--muted); flex-wrap:wrap;
        }
        .lp-key { display:flex; align-items:center; gap:6px; }
        .lp-sw { width:18px; height:10px; border-radius:999px; }
        .lp-count {
          margin-left:auto; font-family:var(--serif); font-style:italic; font-size:22px; color:var(--accent);
          opacity:0; animation:fadeUp .5s ease 2.9s forwards;
        }
        @keyframes fadeUp { from{opacity:0;transform:translateY(4px)} to{opacity:1;transform:none} }

        /* ---- how it works ---- */
        .lp-how {
          max-width:1180px; margin:0 auto; padding:0 16px 48px;
          display:grid; grid-template-columns:1fr; gap:28px;
        }
        .lp-step-n { font-family:var(--serif); font-size:40px; line-height:1; color:var(--accent); margin-bottom:12px; }
        .lp-step h3 { font-family:var(--sans); font-size:16px; font-weight:600; margin:0 0 6px; letter-spacing:0; line-height:1.3; }
        .lp-step p { margin:0; font-size:15px; line-height:1.6; color:var(--muted); }

        /* ---- auth ---- */
        .lp-join { border-top:1px solid var(--line); padding:48px 16px; }
        .lp-join-head { text-align:center; margin-bottom:24px; font-family:var(--serif); font-size:32px; line-height:1.1; letter-spacing:-.01em; }
        .lp-join-head span { display:block; font-family:var(--sans); font-size:15px; color:var(--muted); margin-top:8px; letter-spacing:0; }
        .lp-authwrap { display:flex; justify-content:center; }
        .lp-have { text-align:center; font-size:14px; color:var(--muted); margin:16px 0 0; }
        .lp-have a { color:var(--accent); font-weight:600; }

        /* ---- a match in a phone frame ---- */
        .lp-show { max-width:1180px; margin:0 auto; padding:0 16px 48px; display:grid; gap:28px; align-items:center; justify-items:center; }
        .lp-phone { width:280px; padding:12px; border-radius:44px; background:var(--ink); box-shadow:var(--shadow-pop); }
        .lp-phone-screen { border-radius:34px; background:var(--bg); padding:40px 14px 24px; min-height:420px; }
        .lp-phone-title { font-family:var(--serif); font-size:30px; margin:0 4px 14px; }
        .lp-match { background:var(--surface); border:1px solid var(--line); border-radius:18px; padding:14px; }
        .lp-match-top { display:flex; align-items:center; gap:10px; margin-bottom:10px; }
        .lp-avatar { width:40px; height:40px; border-radius:50%; background:var(--accent-tint); color:var(--accent); font-family:var(--serif); font-size:20px; display:flex; align-items:center; justify-content:center; flex-shrink:0; }
        .lp-match-who { flex:1; min-width:0; display:flex; flex-direction:column; }
        .lp-match-who strong { font-family:var(--serif); font-weight:400; font-size:20px; line-height:1.1; }
        .lp-match-who span { font-size:12px; color:var(--muted); }
        .lp-match-score { font-family:var(--serif); font-size:28px; color:var(--accent); line-height:1; }
        .lp-match-score small { font-size:16px; }
        .lp-match-line { font-size:13px; margin:0 0 10px; line-height:1.45; }
        .lp-match-line b { font-weight:600; }
        .lp-match-free { font-size:12px; color:var(--muted); border-top:1px solid var(--divider); padding-top:10px; margin-bottom:12px; }
        .lp-match-free span { display:block; color:var(--ink); font-weight:600; font-size:13px; }
        .lp-match-actions { display:flex; gap:8px; }
        .lp-fake-btn { flex:1; text-align:center; font-size:13px; font-weight:600; padding:10px 0; border-radius:999px; background:var(--ink); color:#fff; }
        .lp-fake-btn.outline { background:none; color:var(--accent); border:1px solid var(--accent); }
        .lp-show-text { max-width:28rem; text-align:center; }
        .lp-show-text h2 { font-family:var(--serif); font-weight:400; font-size:32px; line-height:1.1; margin:0 0 10px; }
        .lp-show-text p { margin:0; font-size:15px; line-height:1.6; color:var(--muted); }

        .lp-foot { text-align:center; padding:24px 16px 40px; font-size:13px; color:var(--muted); border-top:1px solid var(--line); }
        .lp-foot a { color:var(--muted); text-underline-offset:3px; }

        @media (min-width:768px) {
          .lp-bar { padding:20px 32px; }
          .lp-hero { grid-template-columns:1.05fr .95fr; gap:64px; padding:48px 32px 72px; }
          .lp-h1 { font-size:64px; }
          .lp-ctas { flex-direction:row; align-items:center; }
          .lp-proof { grid-template-columns:repeat(4, auto); justify-content:space-between; padding:0 32px 56px; }
          .lp-panel { padding:28px 24px 24px; }
          .lp-how { grid-template-columns:repeat(3,1fr); gap:40px; padding:0 32px 72px; }
          .lp-join-head { font-size:40px; }
          .lp-show { grid-template-columns:auto 1fr; gap:64px; padding:0 32px 72px; justify-items:start; }
          .lp-show-text { text-align:left; }
          .lp-show-text h2 { font-size:40px; }
        }
        @media (prefers-reduced-motion:reduce) {
          .lp-cell.you, .lp-cell.them, .lp-cell.both, .lp-count { animation:none !important; opacity:1 !important; }
          .lp-cell.you  { background:var(--surface); border-color:var(--ink); }
          .lp-cell.them { background:#9A9F98; border-color:#9A9F98; }
          .lp-cell.both { background:var(--accent); border-color:var(--accent); }
        }
      `}</style>

      <div className="lp-bar">
        <img src="/logo.svg" alt="MedXMeet" className="lp-mark" />
        <a href="#login" className="btn-secondary lp-signin" onClick={e=>{ e.preventDefault(); onSignIn(); }}>Sign in</a>
      </div>

      <div className="lp-hero">
        <div>
          <InviteBanner className="lp-invite" />
          <div className="lp-eyebrow">For medical students</div>
          <h1 className="lp-h1">Study medicine and the USMLE with partners <em>all over the world.</em></h1>
          <p className="lp-sub">
            Mark the hours you can actually study. MedXMeet matches you with students
            preparing for the same exam whose schedule overlaps yours and whose strengths
            fill your gaps — then gives you messaging, a shared calendar, and a video room,
            in any time zone.
          </p>
          <div className="lp-ctas">
            <a href="#signup" className="btn lp-cta" onClick={e=>{ e.preventDefault(); onSignUp(); }}>Create your account</a>
            {APP_STORE_URL && !isNative && (
              <a className="lp-badge" href={APP_STORE_URL} target="_blank" rel="noopener noreferrer"><img src="/app-store-badge.svg" alt="Download on the App Store" /></a>
            )}
          </div>
          <div className="lp-note">Free · USMLE Step 1, Step 2, Step 3 &amp; general study</div>
        </div>

        <div className="lp-panel">
          <div className="lp-panel-top">
            <span>Weekly availability</span>
            <span>Overlap</span>
          </div>
          <div className="lp-grid">
            <div></div>
            {DAYS.map(d => <div key={d} className="lp-day">{d}</div>)}
            {BLOCKS.map((t, r) => (
              <React.Fragment key={t}>
                <div className="lp-time">{t}</div>
                {DAYS.map((d, c) => {
                  const i = r * 7 + c;
                  const both = BOTH.includes(i);
                  const you = !both && YOU.includes(i);
                  const them = !both && THEM.includes(i);
                  const cls = both ? 'both' : you ? 'you' : them ? 'them' : '';
                  const delay = both ? 2.4 + BOTH.indexOf(i) * 0.09
                              : you ? 0.35 + YOU.indexOf(i) * 0.055
                              : them ? 1.4 + THEM.indexOf(i) * 0.055 : 0;
                  return (
                    <div key={d + t} className={`lp-cell ${cls}`}
                         style={cls ? { animationDelay: `${delay}s` } : undefined} />
                  );
                })}
              </React.Fragment>
            ))}
          </div>
          <div className="lp-legend">
            <div className="lp-key"><div className="lp-sw" style={{background:'var(--surface)',border:'1px solid var(--ink)'}} />You</div>
            <div className="lp-key"><div className="lp-sw" style={{background:'#9A9F98'}} />Them</div>
            <div className="lp-key"><div className="lp-sw" style={{background:'var(--accent)'}} />Both</div>
            <div className="lp-count">{BOTH.length} shared slots</div>
          </div>
        </div>
      </div>

      {/* Proof strip (P-4): 2×2 on phones, one row from 768 px. */}
      <ul className="lp-proof">
        <li><Icon name="check" size={20} />No third-party ads · no tracking</li>
        <li><Icon name="clock" size={20} />All 24 hours, any time zone</li>
        <li><Icon name="globe" size={20} />{LANGUAGES.length} study languages</li>
        <li><Icon name="video" size={20} />Private video, no account needed</li>
      </ul>

      <div className="lp-how">
        <div className="lp-step">
          <div className="lp-step-n">01</div>
          <h3>Mark your week</h3>
          <p>Tap the hours you're genuinely free. Click a day to fill it entirely. Add the subjects you're strong in and the ones you're not.</p>
        </div>
        <div className="lp-step">
          <div className="lp-step-n">02</div>
          <h3>See who overlaps</h3>
          <p>Matches weigh how many hours you share, whether your subjects complement each other, and whether you share a study language.</p>
        </div>
        <div className="lp-step">
          <div className="lp-step-n">03</div>
          <h3>Book it and show up</h3>
          <p>Send a request, agree a time, and get a calendar invite with a video room attached. Share notes privately with the people you study with.</p>
        </div>
      </div>

      <div className="lp-show">
        <div className="lp-phone" aria-label="A match in the app">
          <div className="lp-phone-screen">
            <div className="lp-phone-title">Matches</div>
            <div className="lp-match">
              <div className="lp-match-top">
                <div className="lp-avatar">S</div>
                <div className="lp-match-who"><strong>Sofia R.</strong><span>Year 2 · Step 1</span></div>
                <div className="lp-match-score">86<small>%</small></div>
              </div>
              <p className="lp-match-line">Teaches you <b>Pharmacology</b> · learns <b>Anatomy</b> from you</p>
              <div className="lp-match-free"><span>Free together</span>Mon–Fri 18:00–20:00</div>
              <div className="lp-match-actions"><span className="lp-fake-btn">Message</span><span className="lp-fake-btn outline">Schedule</span></div>
            </div>
          </div>
        </div>
        <div className="lp-show-text">
          <h2>Every match says why.</h2>
          <p>What they can teach you, what you can teach them, and the hours you're both free, in your own time zone.</p>
        </div>
      </div>

      <div className="lp-join" id="join">
        <div className="lp-join-head">
          Start studying with someone
          <span>Takes a minute. You can fill in your schedule after.</span>
        </div>
        <div className="lp-authwrap">
          <button className="btn lp-cta" onClick={onSignUp}>Create your account</button>
        </div>
        <p className="lp-have">Already have an account? <a href="#login" onClick={e=>{ e.preventDefault(); onSignIn(); }}>Sign in</a></p>
      </div>

      <div className="lp-foot">
        <a href={siteUrl('/terms.html')}>Terms of Use</a> · <a href={siteUrl('/privacy.html')}>Privacy Policy</a> · <a href={siteUrl('/support.html')}>Support</a> · <a href="mailto:support@medxmeet.com">support@medxmeet.com</a>
        <p className="lp-tm">MedXMeet is not affiliated with or endorsed by the FSMB or NBME. USMLE® is a registered trademark of the FSMB and NBME.</p>
      </div>
    </div>
  );
}

export default Landing;